import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import EntryFunnelPage from './EntryFunnelPage';
import FunnelPage from './FunnelPage';

// Admin v2 · V10 — one Funnel destination, two lenses:
//   Session entry — the M4 mechanics (session_start → first_answer per surface)
//   Sources       — reel → web → signup attribution (marketing/campaigns)
// The wrapped pages render unchanged; this is deliberately a thin shell so the
// merge carries zero regression risk.
export default function FunnelHubPage() {
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState(searchParams.get('tab') === 'sources' ? 'sources' : 'entry');

  return (
    <div>
      <div className="px-6 pt-5 flex items-center gap-2">
        <div className="flex items-center bg-white border border-teacher-border rounded-lg p-0.5 text-xs font-medium text-teacher-text-secondary">
          <button
            onClick={() => setTab('entry')}
            className={`px-3.5 py-1.5 rounded-md transition-colors ${tab === 'entry' ? 'bg-primary-600 text-white font-semibold' : 'hover:text-primary-700'}`}
          >
            Session entry
          </button>
          <button
            onClick={() => setTab('sources')}
            className={`px-3.5 py-1.5 rounded-md transition-colors ${tab === 'sources' ? 'bg-primary-600 text-white font-semibold' : 'hover:text-primary-700'}`}
          >
            Sources
          </button>
        </div>
        <span className="text-xs text-teacher-text-tertiary">
          {tab === 'entry' ? 'where sessions die before question 1' : 'which campaigns sent them'}
        </span>
      </div>
      {tab === 'entry' ? <EntryFunnelPage /> : <FunnelPage />}
    </div>
  );
}
